import {
  resolveTranslationLanguage,
  TranslationLanguage,
  TranslationMessages,
} from './languages';

export * from './languages';

type CatalogModule = { default: TranslationMessages };

const CATALOGS: Record<TranslationLanguage, () => Promise<CatalogModule>> = {
  de: () => import('./de.json'),
  'en-US': () => import('./en-US.json'),
  es: () => import('./es.json'),
  fr: () => import('./fr.json'),
  he: () => import('./he.json'),
  hu: () => import('./hu.json'),
  it: () => import('./it.json'),
  ka: () => import('./ka.json'),
  kk: () => import('./kk.json'),
  pl: () => import('./pl.json'),
  pt: () => import('./pt.json'),
  ro: () => import('./ro.json'),
  ru: () => import('./ru.json'),
  uk: () => import('./uk.json'),
};

export const loadTranslations = async (
  language: string,
): Promise<TranslationMessages> => {
  const resolved = resolveTranslationLanguage(language);

  return resolved ? (await CATALOGS[resolved]()).default : {};
};
